import React from "react";
import PropTypes from "prop-types";
import { propTypes } from "react-bootstrap/esm/Image";

const TextInputForArchieve = ({
  name,
  id,
  label,
  value,
  onChange,
  placeholder,
  required,
  disabled,
  errorMessage,
  type,
  onBlur,
  onKeyDown,
  maxLength = 100,
}) => {
  return (
    <div>
      <label
        className="w-100 fs-5 mb-1 inmate-label"
      >
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div>
        <input
          type={type}
          className={`form-control mb-5px fs-5 ${errorMessage ? "border-danger" : ""
            } fw-normal`}
          placeholder={placeholder}
          name={name}
          id={id}
          value={value}
          onChange={onChange} // Corrected
          onBlur={onBlur} // Corrected
          required={false}
          disabled={disabled}
          maxLength={maxLength}
          onKeyDown={onKeyDown}
        />
        {errorMessage && (
          <div className="text-danger fw-700 fs-6 mt-1">{errorMessage}</div>
        )}
      </div>
    </div>
  );
};

TextInputForArchieve.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired, // Updated to `onChange`
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  type: PropTypes.string.isRequired,
  onBlur: PropTypes.func, // Updated to `onBlur`
  onKeyDown: PropTypes.func,
};

TextInputForArchieve.defaultProps = {
  placeholder: "",
  required: false,
  disabled: false,
  id: "",
  errorMessage: "",
};

export default TextInputForArchieve;
